<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port Name</th>
        <th class="text-sm">Status</th>
        <th class="text-sm">Registered</th>
        <th class="text-sm">Active</th>
        <th class="text-sm">Online</th>
        <th class="text-sm">Total</th>
        <th class="text-sm">Alarms</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="7">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="!portData || portData.length === 0">
        <tr>
          <td colspan="7" class="text-center text-muted p-4">
              No port data available
          </td>
        </tr>
      </template>
      <template v-else>
        <tr
          v-for="port in portData"
          :key="port.Index"
        >
          <td class="text-sm">
            <span class="port-name">{{ port.Name }}</span>
          </td>
          <td class="text-sm">
            <span
              class="badge"
              :class="getStatusBadgeClass(port.Status)"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ getStatusText(port.Status) }}
            </span>
          </td>
          <td class="text-sm">{{ port.data?.Register || 0 }}</td>
          <td class="text-sm">{{ port.data?.Active || 0 }}</td>
          <td class="text-sm">{{ port.data?.Online || 0 }}</td>
          <td class="text-sm">{{ port.data?.Total || 0 }}</td>
          <td class="text-sm" :class="port.data?.OnuAlarm > 0 ? 'text-danger' : 'text-muted'">
            {{ port.data?.OnuAlarm || 0 }}
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'EponClodePortSummary',
  components: {
    Skalaton
  },
  props: {
    portData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalPorts() {
      return this.portData?.length || 0;
    },
    activePorts() {
      return this.portData?.filter(port => port.Status === 2).length || 0;
    },
    inactivePorts() {
      return this.portData?.filter(port => port.Status === 0).length || 0;
    },
    totalOnus() {
      return this.portData?.reduce((sum, port) => sum + (port.data?.Total || 0), 0) || 0;
    },
    onlineOnus() {
      return this.portData?.reduce((sum, port) => sum + (port.data?.Online || 0), 0) || 0;
    },
    offlineOnus() {
      return this.totalOnus - this.onlineOnus;
    }
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        0: 'Inactive',
        1: 'Initializing',
        2: 'Active',
        3: 'Failed'
      };
      return statusMap[status] || 'Unknown';
    },
    
    getStatusBadgeClass(status) {
      const classMap = {
        0: 'bg-secondary', // Inactive
        1: 'bg-warning',   // Initializing
        2: 'bg-success',   // Active
        3: 'bg-danger'     // Failed
      };
      return classMap[status] || 'bg-secondary';
    }
  }
}
</script>